import React from 'react';
import { ScopeOfAdviceTab } from '@/components/views/DealView/DealViewTabs/ScopeOfAdviceTab';
import { ActivityTab } from '@/components/objectTabs/ActivityTab';
import { NotesTab } from '@/components/objectTabs/NotesTab';
import { TasksTab } from '@/components/objectTabs/TasksTab';
import { AttachmentsTab } from '@/components/objectTabs/AttachmentsTab';
import { FormsTab } from '@/components/objectTabs/FormsTab';
import { WorkspaceTab } from '@/components/objectTabs/WorkspaceTab';
import { RiskTab } from '@/components/views/DealView/DealViewTabs/RiskTab';
import { QuotesTab } from '@/components/views/DealView/DealViewTabs/QuotesTab';
import { ClaimDetailsTab } from '@/components/views/DealView/DealViewTabs/ClaimDetailsTab';
import { PolicyTransactionTab } from '@/components/views/ClientView/ClientTabs/PolicyTransactionTab';
import { ClaimsTab } from '@/components/views/ClientView/ClientTabs/ClaimsTab';
import { paths } from './routes';
import TemplateTableTab from '@/components/views/EmailView/EmailViewTabs/TemplateTableTab';
import CreateEmailTemplateForm from '@/components/forms/CreateEmailTemplateForm';
import { Navigate } from 'react-router-dom';
import { InsightPolicyTransactionTab } from '@/components/views/ClientView/ClientTabs/InsightPolicyTransactionsTab';
import AIHtmlTemplateTableTab from '@/components/views/EmailView/EmailViewTabs/AIHtmlTemplateTableTab';
import { DebtorDetailsTab } from '@/components/views/DebtorsView/DebtorsTabs/DebtorDetailsTab';
import { DebtorsTab } from '@/components/views/ClientView/ClientTabs/DebtorsTab';
import { ConfigTableView } from '@/components/views/ConfigTableView';
import RelationshipCompanyDetailsTab from '@/components/views/RelationshipCompanyView/RelationshipCompanyTabs/RelationshipCompanyDetailsTab';
import RelationshipCompanyContactsTab from '@/components/views/RelationshipCompanyView/RelationshipCompanyTabs/RelationshipCompanyContactsTab';
import { EditPipelinesView } from '@/components/views/EditPipelinesView';
import { UnlayerEmailTemplatesTab } from '@/components/views/UnlayerEmailsView/UnlayerEmailsTabs/UnlayerEmailTemplatesTab';
import { UnlayerAiEmailTemplatesTab } from '@/components/views/UnlayerEmailsView/UnlayerEmailsTabs/UnlayerAiEmailTemplatesTab';
import { UserSettings } from '@/components/views/SettingsView/UserSettings';
import { PrimaryBrokerageSettings } from '@/components/views/SettingsView/BrokerageSettings';
import { BrokerageGroupsTable } from '@/components/views/SettingsView/BrokerageGroupsTable';
import EmailNotificationSettings from '@/components/views/SettingsView/EmailNotifications';
import { BrokerageUsersTable } from '@/components/views/SettingsView/BrokerageUsersTable';
import UpdateClientForm from '@/components/forms/UpdateClientForm';

export const getDealTabs = (path) => [
	{
		label: 'Deal Details',
		value: '',
		alias: 'deal-details',
		showComponent: path !== paths.claims && path !== paths.debtors,
		ContentComponent: ScopeOfAdviceTab,
	},
	{
		label: 'Claim details',
		value: '',
		alias: 'claim-details',
		showComponent: path === paths.claims,
		ContentComponent: ClaimDetailsTab,
	},
	{
		label: 'Activity',
		value: 'activity',
		showComponent: true,
		ContentComponent: ActivityTab,
	},
	{
		label: 'Workspace',
		value: 'workspace',
		showComponent: true,
		ContentComponent: WorkspaceTab,
	},
	{
		label: 'Notes',
		value: 'notes',
		showComponent: true,
		ContentComponent: NotesTab,
	},
	{
		label: 'Tasks',
		value: 'tasks',
		showComponent: true,
		ContentComponent: TasksTab,
	},

	{
		label: 'Documents',
		value: 'attachments',
		showComponent: true,
		ContentComponent: AttachmentsTab,
	},
	{
		label: 'Forms',
		value: 'forms',
		showComponent: path !== paths.debtors,
		ContentComponent: FormsTab,
	},
	{
		label: 'Risk Info',
		value: 'risk',
		showComponent: path !== paths.claims && path !== paths.debtors,
		ContentComponent: RiskTab,
	},
	{
		label: 'Quotes',
		value: 'quotes',
		showComponent: path !== paths.claims && path !== paths.debtors,
		ContentComponent: QuotesTab,
	},
];

export const getClientTabs = (path) => [
	{
		label: 'Deals',
		value: '',
		alias: 'deals',
		ContentComponent: PolicyTransactionTab,
	},
	{
		label: 'Policies',
		value: 'policies',
		ContentComponent: InsightPolicyTransactionTab,
	},
	{
		label: 'Activity',
		value: 'activity',
		ContentComponent: ActivityTab,
	},
	{
		label: 'Claims',
		value: 'claims',
		ContentComponent: ClaimsTab,
	},
	{
		label: 'Debtors',
		value: 'debtors',
		ContentComponent: DebtorsTab,
	},
	// {
	// 	label: 'Workspace',
	// 	value: 'workspace',
	// 	showComponent: true,
	// 	ContentComponent: WorkspaceTab,
	// },
	{
		label: 'Workspace',
		value: 'workspace',
		showComponent: true,
		ContentComponent: WorkspaceTab,
	},
	{
		label: 'Notes',
		value: 'notes',
		ContentComponent: NotesTab,
	},
	{
		label: 'Tasks',
		value: 'tasks',
		ContentComponent: TasksTab,
	},
	{
		label: 'Documents',
		value: 'attachments',
		ContentComponent: AttachmentsTab,
	},
	{
		label: 'Forms',
		value: 'forms',
		ContentComponent: FormsTab,
	},
	{
		label: 'Client details',
		value: 'details',
		ContentComponent: UpdateClientForm,
	},
];

export const getRelationshipCompanyTabs = () => [
	{
		label: 'Contacts',
		value: '',
		alias: 'contacts',
		showComponent: true,
		ContentComponent: RelationshipCompanyContactsTab,
	},
	{
		label: 'Activity',
		value: 'activity',
		showComponent: true,
		ContentComponent: ActivityTab,
	},
	{
		label: 'Workspace',
		value: 'workspace',
		showComponent: true,
		ContentComponent: WorkspaceTab,
	},
	{
		label: 'Notes',
		value: 'notes',
		showComponent: true,
		ContentComponent: NotesTab,
	},
	{
		label: 'Tasks',
		value: 'tasks',
		showComponent: true,
		ContentComponent: TasksTab,
	},
	{
		label: 'Documents',
		value: 'attachments',
		showComponent: true,
		ContentComponent: AttachmentsTab,
	},
	{
		label: 'Details',
		value: 'details',
		showComponent: true,
		ContentComponent: RelationshipCompanyDetailsTab,
	},
];

export const getDebtorTabs = (path) => [
	{
		label: 'Debtor Details',
		value: '',
		alias: 'debtor-details',
		showComponent: true,
		ContentComponent: DebtorDetailsTab,
	},
	{
		label: 'Activity',
		value: 'activity',
		showComponent: true,
		ContentComponent: ActivityTab,
	},
	{
		label: 'Notes',
		value: 'notes',
		showComponent: true,
		ContentComponent: NotesTab,
	},
	{
		label: 'Tasks',
		value: 'tasks',
		showComponent: true,
		ContentComponent: TasksTab,
	},
	{
		label: 'Documents',
		value: 'attachments',
		showComponent: true,
		ContentComponent: AttachmentsTab,
	},
];

export const getSettingsTabs = (path) => [
	{
		label: 'User profile',
		value: 'user',
		ContentComponent: UserSettings,
		showComponent: true,
	},
	{
		label: 'Brokerage profile',
		value: 'brokerage',
		ContentComponent: PrimaryBrokerageSettings,
		showComponent: true,
	},
	{
		label: 'Broker Groups',
		value: 'brokerGroups',
		ContentComponent: BrokerageGroupsTable,
		showComponent: true,
	},
	{
		label: 'Email notifications',
		value: 'notifications',
		ContentComponent: EmailNotificationSettings,
		showComponent: true,
	},

	{
		label: 'Pipelines',
		value: 'pipelines',
		ContentComponent: EditPipelinesView,
		showComponent: true,
	},

	{
		label: 'Client config',
		value: 'config',
		ContentComponent: ConfigTableView,
		showComponent: true,
	},
	{
		label: 'Users',
		value: 'users',
		ContentComponent: BrokerageUsersTable,
		showComponent: true,
	},
];

export const getUnlayerEmailTabs = (path) => [
	{
		label: 'Emails',
		value: '',
		ContentComponent: UnlayerEmailTemplatesTab,
		showComponent: true,
	},
	{
		label: 'AI templates',
		value: 'ai-templates',
		ContentComponent: UnlayerAiEmailTemplatesTab,
		showComponent: true,
	},
];

export const getTemplateTabs = (path) => [
	{
		label: 'Templates',
		value: '',
		ContentComponent: TemplateTableTab,
		showComponent: true,
	},
	{
		label: 'Create Template',
		value: 'create',
		ContentComponent: CreateEmailTemplateForm,
		showComponent: true,
	},
	{
		label: 'AI Html Templates',
		value: 'aiTemplates',
		ContentComponent: AIHtmlTemplateTableTab,
		showComponent: true,
	},
];

export const determineTabChildren = (children) =>
	children
		.filter((t) => t.showComponent != false && t.ContentComponent)
		.reduce((acc, tab) => {
			const { value: path, alias, ContentComponent } = tab;
			if (acc?.[0]?.path !== '') {
				acc.push({ path: '', element: <ContentComponent /> });
			}
			acc.push({ path, element: <ContentComponent /> });
			if (path === '' && alias) {
				acc.push({ path: alias, element: <ContentComponent /> });
			}
			return acc;
		}, [])
		.concat({
			path: '*',
			element: <Navigate to='..' replace />,
		});
